import { createApp } from 'vue'

// Style
import './assets/scss/style.scss'

// Create app
import BookingApp from '@views/Booking.vue'


// State management
import { createPinia } from 'pinia/dist/pinia.mjs'
// Use router
import router from '@routes/booking.js'

function Log() {
    // if (!prebook_frontend.debug) return
    const args = Array.prototype.slice.call(arguments)
    console.log('%c[Prebook]', 'background: purple; color: #fff; font-size: 10px; padding: 1px 2px; border-radius: 3px', ...args)
}

// Mount
const mountables = document.querySelectorAll('[data-prebook-booking]')
if (mountables && mountables.length) {

    mountables.forEach(mountable => {

        // Widget Mode.
        const isWidgetMode = document.querySelector('[data-prebook-widget]')
        const app = createApp(BookingApp)
        app.use(createPinia())
        app.use(router())
        app.mount(mountable)
        app.config.globalProperties.Log = Log
        app.config.globalProperties.Image = (path) => {
            return prebook.url.assets + 'images/' + path
        }

    })
}


window.Log = Log

// rtl
import { useSettings } from '@store/settings'
const $settings = useSettings()

document.addEventListener('DOMContentLoaded', () => {
    if ($settings.isRTL) {
        document.querySelector('html').setAttribute('dir', 'rtl')
    }
})